export interface SelectValuesInterface {
  option: string;
  value: string;
}

export enum BusinessLine {
  BABYSITTER = 'BABYSITTER',
  PETSITTER = 'PETSITTER',
  NURSE = 'NURSE',
  COLF = 'COLF',
  NUTRITIONIST = 'NUTRITIONIST',
  COACH = 'COACH',
  PSYCHOLOGIST = 'PSYCHOLOGIST',
  VIDEO_CONSULTATION = 'VIDEO_CONSULTATION',
  IN_PERSON = 'IN_PERSON',
  LONGEVITY = 'LONGEVITY',
  CAREGIVER_CONSULT = 'CAREGIVER_CONSULT',
}

export const BUSINESS_LINE_OPTIONS: Array<SelectValuesInterface> = [
  {
    option: 'BABYSITTER',
    value: BusinessLine.BABYSITTER,
  },
  {
    option: 'NUTRIZIONISTI',
    value: BusinessLine.NUTRITIONIST,
  },
  {
    option: 'PETSITTER',
    value: BusinessLine.PETSITTER,
  },
  {
    option: 'BADANTI',
    value: BusinessLine.NURSE,
  },
  {
    option: 'COLF',
    value: BusinessLine.COLF,
  },
  {
    option: 'COACH',
    value: BusinessLine.COACH,
  },
  {
    option: 'PSYCHOLOGIST',
    value: BusinessLine.PSYCHOLOGIST,
  },
  {
    option: 'VIDEO CONSULTO',
    value: BusinessLine.VIDEO_CONSULTATION,
  },
  {
    option: 'VISITA MEDICA DI PERSONA',
    value: BusinessLine.IN_PERSON,
  },
  {
    option: 'LONGEVITY',
    value: BusinessLine.LONGEVITY,
  },
  {
    option: 'SUPPORTO CAREGIVER',
    value: BusinessLine.CAREGIVER_CONSULT,
  },
];
